import { render } from "./MasterDataTableList.vue?vue&type=template&id=18ea2ad6&scoped=true&ts=true"
import script from "./MasterDataTableList.vue?vue&type=script&lang=ts"
export * from "./MasterDataTableList.vue?vue&type=script&lang=ts"

import "./MasterDataTableList.vue?vue&type=style&index=0&id=18ea2ad6&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ea2ad6"]])

export default __exports__